import React, { useState, useEffect } from 'react';
import { DatePickerInput } from 'rc-datepicker';
import { DatePicker } from 'components/sales/datePicker/datePicker';
import { Button, FormGroup } from 'react-bootstrap';
import localization from 'assets/localization/localization';
import PropTypes from 'prop-types';
import moment from 'moment';

const CardLayout = ({ count, listData, data, handleValue, minDateIndex,itemId }) => {
  const [isFocus, setIsFous] = useState(true);
  const [stageData, setStageData] = useState({
    stage_id: '',
    expected_closure_date: '',
    sequence_id:'',
  });

  const handleDateHide = () => {};
  useEffect(() => {
    handleFormData();
  }, [stageData]);
  
  useEffect(() => {
     if(data?.expected_closure_date) {
        setStageData({
          ...stageData,
          expected_closure_date: data?.expected_closure_date,
          stage_id: data.id,
          sequence_id: data.sequence_id
        }); 
        handleFormData();
     }
  },[data?.expected_closure_date]);

  const handleFormData = () => {
    // console.log(stageData); return ;
    if (stageData?.expected_closure_date !== '') {
      handleValue({
        stageData,
      });
    } else {
      handleValue(null);
    }
  };

  return (
    <div className="panel-card">
      <div className="panel-heading">{data.name}</div>
      <div className="panel-body">
        <div className="form-group">
          <FormGroup
            className={`date custom_date_picker ${
              isFocus ? 'active-date' : ''
            }`}
          >
            <DatePickerInput
              onChange={(date, dateString) => {
                setStageData({
                  ...stageData,
                  expected_closure_date: dateString,
                  stage_id: data.id,
                  sequence_id: data.sequence_id
                });
              }}
              value={stageData?.expected_closure_date ? stageData?.expected_closure_date : (data?.expected_closure_date) ? data?.expected_closure_date : stageData?.expected_closure_date}
              autoClose
              onShow={() => setIsFous(true)}
              onHide={handleDateHide}
              closeOnClickOutside
              showOnInputClick
              placeholder={
                count === 1 || itemId === 10 || minDateIndex !== undefined
                  ? null
                  : `Previous Date must be selected.`
              }
              locale="en"
              className="my-custom-datepicker-component"
              minDate={
                //  moment(minDateIndex).add(1, 'days')
                moment(minDateIndex)
              }
              startDate={
                // moment(minDateIndex).add(1, 'days')
                moment(minDateIndex)
              }
              // minDate={
              //   count === 3
              //     ? new Date(listData[count]).getTime() <
              //       new Date(listData[count - 1]).getTime()
              //       ? moment(listData[count - 1]).add(1, 'days')
              //       : moment(listData[count]).add(1, 'days')
              //     : minDateIndex && count !== 2
              //     ? moment(minDateIndex).add(1, 'days')
              //     : moment()
              // }
              // startDate={
              //   count === 3
              //     ? new Date(listData[count]).getTime() <
              //       new Date(listData[count - 1]).getTime()
              //       ? moment(listData[count - 1]).add(1, 'days')
              //       : moment(listData[count]).add(1, 'days')
              //     : minDateIndex && count !== 2
              //     ? moment(minDateIndex).add(1, 'days')
              //     : moment()
              // }
              required
              disabled={
                count === 1 || itemId === 10 || minDateIndex !== undefined || (data?.expected_closure_date) ? false : true
              }
            />
            <label>
              {data.name} {localization.expectedClosureDate}
              <span className="label-star" style={{ color: 'red' }}>
                {' '}
                *{' '}
              </span>
            </label>
            {stageData.expected_closure_date === '' && (
              <label
                className={
                  localization.expectedClosure === ''
                    ? 'error'
                    : 'error date_error'
                }
              >
                {localization.isRequired}
              </label>
            )}
          </FormGroup>
        </div>
      </div>
    </div>
  );
};

CardLayout.propTypes = {};

export default CardLayout;
